import { useAppSelector } from '~/app/hooks'
import { isDarkTheme } from '~/redux/features'

export function EFPendingIcon() {
  const isDark = useAppSelector(isDarkTheme)
  const fill = isDark ? 'var(--color-dark-theme)' : '#666666'
  return (
    <svg
      width='21'
      height='21'
      viewBox='0 0 21 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16.159 8.02999L9.08902 15.1L4.84902 10.86L6.25902 9.44999L9.08902 12.28L14.749 6.61999L16.159 8.02999ZM2.49902 10.5C2.49902 8.16999 3.51902 6.07999 5.11902 4.61999L7.49902 6.99999V0.999988H1.49902L3.69902 3.19999C1.73902 5.01999 0.499023 7.60999 0.499023 10.5C0.499023 15.69 4.44902 19.95 9.49902 20.45V18.43C5.55902 17.94 2.49902 14.57 2.49902 10.5ZM20.499 10.5C20.499 5.30999 16.549 1.04999 11.499 0.549988V2.56999C15.439 3.05999 18.499 6.42999 18.499 10.5C18.499 12.83 17.479 14.92 15.879 16.38L13.499 14V20H19.499L17.299 17.8C19.259 15.98 20.499 13.39 20.499 10.5Z'
        fill={fill}
      />
    </svg>
  )
}
